import { createFileRoute, redirect } from "@tanstack/react-router";
import { Role } from "@/core/components/auth/auth.types";
import { ErrorComponent } from "@/core/components/ErrorComponent";
import { LoadingList } from "@/core/components/LoadingList";
import { getEvents } from "@/core/components/sites/site/events/eventsQueryOptions";
import { ratesQueryOptions } from "@/core/components/sites/site/rates-and-packages/rates/ratesQueryOptions";
import { getRoomBlockById } from "@/core/components/sites/site/room-blocks/roomBlocksQueryOptions";
import { roomsQueryOptions } from "@/core/components/sites/site/rooms/roomQueryOptions";

export const Route = createFileRoute(
	"/_layout/dashboard/sites/$siteId/room-blocks/$roomBlockId/edit/",
)({
	beforeLoad: ({ context: { auth } }) => {
		if (auth.isExpired()) {
			return;
		}
		if (!auth.isAuthenticated) {
			throw redirect({
				to: "/",
			});
		}
		if (
			auth.user?.role === Role["Front-Desk"] ||
			auth.user?.role === Role["Blogger"]
		) {
			throw redirect({
				to: "/dashboard",
			});
		}
	},
	loader: ({
		context: { queryClient, auth },
		params: { siteId, roomBlockId },
	}) => {
		const roomBlock = queryClient.ensureQueryData(
			getRoomBlockById(siteId, auth.token!, roomBlockId),
		);
		void queryClient.ensureQueryData(roomsQueryOptions(siteId, auth.token!));
		void queryClient.ensureQueryData(ratesQueryOptions(siteId, auth.token!));
		void queryClient.ensureQueryData(getEvents(siteId, auth.token!));
		return { roomBlock };
	},
	pendingComponent: LoadingList,
	errorComponent: ErrorComponent,
});
